// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__-ez5-","dragIcon":"Choice_dragIcon__20FWM","left":"Choice_left__1qHRc","input":"Choice_input__3Du3P"};